import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'

import DataRemove from './component'

export default combine(
  withContext(
    'registerService',
    ServicesContext,
    ({ registerService }) => registerService
  ),
  withCallbacks(
    {
      onSubmit:
        ({ registerService }) =>
        async (form) => {
          await registerService.requestDataDeletion(form)
          toaster.success('Your application has been sent')
        },
    },
    []
  )
)(DataRemove)
